/**
 * The voucher types a person may pick when entering a voucher by hand.
 * @file src/web/shared/utils/voucher-types.ts
 *
 * The same eight the server accepts (api/features/books/voucher-types.ts —
 * a test holds the two lists equal). In the order they are offered.
 */
export const VOUCHER_TYPES = ['Sales', 'Purchase', 'Payment', 'Receipt', 'Journal', 'Contra', 'Debit Note', 'Credit Note'] as const;
export const DEFAULT_VOUCHER_TYPE = 'Journal';
